import AvatarTestimonio from "../../img/person.svg"

export const testimonios = [
  {
    id: 1,
    nombre: "Pedro Morales",
    cargo: "Alumno de Angular",
    avatar: 'https://firebasestorage.googleapis.com/v0/b/academia-temple.appspot.com/o/testimonios%2Ftestimonio1.jpg?alt=media&token=edb97f1d-cb43-4427-b0c8-a2e85f8676e8',
    contenido:
      "Academia Temple, el mejor lugar donde se aprende a programar los lenguajes mas demandados laboralmente. Actualmente con profesores altamente calificados y con una gran pedadogia para la enseñanza.",
    numEstrellas: 5
  },
  {
    id: 2,
    nombre: "Joel Ronceros",
    cargo: "Alumno de C++",
    avatar: 'https://firebasestorage.googleapis.com/v0/b/academia-temple.appspot.com/o/testimonios%2Ftestimonio2.jpg?alt=media&token=1ca11893-459d-4d5d-93d6-3f7eb7cb558f',
    contenido:
      "Gracias a la academia temple aprendi a progranar y conseguir mi primer trabajo!",
    numEstrellas: 5
  },
  {
    id: 3,
    nombre: "Lucas Lopez",
    cargo: "Alumno de inglés",
    avatar: AvatarTestimonio,
    contenido:
      "El mejor lugar para aprender programación e inglés. Gracias a este proyecto pude aprender mucho.",
    numEstrellas: 5
  },
]
